<div class="billing-information-container" [formGroup]="billingInfoForm">
    <div *ngIf="editUsersProfile; else defaultBlock">
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngIf="editUsersProfileVisitor">
                <ng-container *ngTemplateOutlet="visitorBlock"></ng-container>
            </ng-container>
        </div>
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngIf="editUsersProfileInvoice">
                <ng-container *ngTemplateOutlet="invoiceBlock"></ng-container>
            </ng-container>
        </div>
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngIf="editUsersProfileDelivery">
                <ng-container *ngTemplateOutlet="deliveryBlock"></ng-container>
            </ng-container>
        </div>
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngIf="editUsersProfileFinancial">
                <ng-container *ngTemplateOutlet="financialBlock"></ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #defaultBlock>
    <div class="row" [formGroup]="billingInfoForm">
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngTemplateOutlet="visitorBlock"></ng-container>
        </div>
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngTemplateOutlet="invoiceBlock"></ng-container>
        </div>
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngTemplateOutlet="deliveryBlock"></ng-container>
        </div>
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngTemplateOutlet="generalBlock"></ng-container>
        </div>
        <div class="kt-portlet kt-portlet--mobile">
            <ng-container *ngTemplateOutlet="financialBlock"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #visitorBlock>
    <h5 class="kt-portlet__head-title"><span translation="Visitor" source=""></span></h5>
    <div class="kt-portlet__body" [formGroup]="billingInfoForm">
        <div class="row">
            <div class="form-group col-12 col-sm-4">
                <label for="LegalName">
                    <span translation="LegalName" source=""></span> <span *ngIf="isControlRequired('visitorLegalName')">*</span>
                </label>
                <input id="LegalName"
                       type="text"
                       name="legalName"
                       class="form-control"
                       formControlName="visitorLegalName"
                       [ngClass]="{'edited':billingInfo.legalName}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('visitorLegalName')"
                                     [formCtrl]="billingInfoForm.get('visitorLegalName')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="VisitorContactName">
                    <span translation="ContactName" source=""></span> <span *ngIf="isControlRequired('visitorContactName')">*</span>
                </label>
                <input id="VisitorContactName"
                       type="text"
                       name="contactName"
                       class="form-control"
                       formControlName="visitorContactName"
                       [ngClass]="{'edited':billingInfo.contactName}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('visitorContactName')"
                                     [formCtrl]="billingInfoForm.get('visitorContactName')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="Address">
                    <span translation="Address" source=""></span> <span *ngIf="isControlRequired('visitorAddress')">*</span>
                </label>
                <textarea id="Address"
                          rows="1"
                          name="address"
                          class="form-control"
                          [ngClass]="{'edited':billingInfo.address}"
                          formControlName="visitorAddress"
                          maxlength="256"></textarea>

                <validation-messages *ngIf="isControlRequired('visitorAddress')"
                                     [formCtrl]="billingInfoForm.get('visitorAddress')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="addressHouseNumber">
                    <span translation="AddressHouseNumber" source=""></span> <span *ngIf="isControlRequired('visitorAddressHouseNumber')">*</span>
                </label>
                <input id="addressHouseNumber"
                       type="text"
                       name="houseNumber"
                       class="form-control"
                       formControlName="visitorAddressHouseNumber"
                       [ngClass]="{'edited':billingInfo.addressHouseNumber}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('visitorAddressHouseNumber')"
                                     [formCtrl]="billingInfoForm.get('visitorAddressHouseNumber')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="addressPostcode">
                    <span translation="AddressPostcode" source=""></span> <span *ngIf="isControlRequired('visitorAddressPostcode')">*</span>
                </label>
                <input id="addressPostcode"
                       type="text"
                       name="addressPostcode"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.addressPostcode}"
                       formControlName="visitorAddressPostcode"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('visitorAddressPostcode')"
                                     [formCtrl]="billingInfoForm.get('visitorAddressPostcode')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="addressCity">
                    <span translation="AddressCity" source=""></span> <span *ngIf="isControlRequired('visitorAddressCity')">*</span>
                </label>
                <input id="addressCity"
                       type="text"
                       name="city"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.addressCity}"
                       formControlName="visitorAddressCity"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('visitorAddressCity')"
                                     [formCtrl]="billingInfoForm.get('visitorAddressCity')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="addressCountry">
                    <span translation="AddressCountry" source=""></span> <span *ngIf="isControlRequired('visitorAddressCountry')">*</span>
                </label>
                <input id="addressCountry"
                       type="text"
                       name="addressCountry"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.addressCountry}"
                       formControlName="visitorAddressCountry"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('visitorAddressCountry')"
                                     [formCtrl]="billingInfoForm.get('visitorAddressCountry')"></validation-messages>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #invoiceBlock>
    <h5 class="kt-portlet__head-title"><span translation="Invoice" source=""></span></h5>
    <div class="kt-portlet__body" [formGroup]="billingInfoForm">
        <div class="row">
            <div class="form-group col-12 col-sm-4">
                <label for="invoiceContactName">
                    <span translation="ContactName" source=""></span> <span *ngIf="isControlRequired('invoiceContactName')">*</span>
                </label>
                <input id="invoiceContactName"
                       type="text"
                       name="invoiceContactName"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.invoiceContactName}"
                       formControlName="invoiceContactName"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('invoiceContactName')"
                                     [formCtrl]="billingInfoForm.get('invoiceContactName')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="invoiceAddress">
                    <span translation="Address" source=""></span> <span *ngIf="isControlRequired('invoiceAddress')">*</span>
                </label>
                <textarea id="invoiceAddress"
                          rows="1"
                          name="address"
                          class="form-control"
                          [ngClass]="{'edited':billingInfo.invoiceAddress}"
                          formControlName="invoiceAddress"
                          maxlength="256"></textarea>

                <validation-messages *ngIf="isControlRequired('invoiceAddress')"
                                     [formCtrl]="billingInfoForm.get('invoiceAddress')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="invoiceAddressHouseNumber">
                    <span translation="AddressHouseNumber" source=""></span> <span *ngIf="isControlRequired('invoiceAddressHouseNumber')">*</span>
                </label>
                <input id="invoiceAddressHouseNumber"
                       type="text"
                       name="houseNumber"
                       class="form-control"
                       formControlName="invoiceAddressHouseNumber"
                       [ngClass]="{'edited':billingInfo.invoiceAddressHouseNumber}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('invoiceAddressHouseNumber')"
                                     [formCtrl]="billingInfoForm.get('invoiceAddressHouseNumber')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="invoiceAddressPostcode">
                    <span translation="AddressPostcode" source=""></span> <span *ngIf="isControlRequired('invoiceAddressPostcode')">*</span>
                </label>
                <input id="invoiceAddressPostcode"
                       type="text"
                       name="invoiceAddressPostcode"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.invoiceAddressPostcode}"
                       formControlName="invoiceAddressPostcode"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('invoiceAddressPostcode')"
                                     [formCtrl]="billingInfoForm.get('invoiceAddressPostcode')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="invoiceAddressCity">
                    <span translation="AddressCity" source=""></span> <span *ngIf="isControlRequired('invoiceAddressCity')">*</span>
                </label>
                <input id="invoiceAddressCity"
                       type="text"
                       name="city"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.invoiceAddressCity}"
                       formControlName="invoiceAddressCity"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('invoiceAddressCity')"
                                     [formCtrl]="billingInfoForm.get('invoiceAddressCity')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="invoiceAddressCountry">
                    <span translation="AddressCountry" source=""></span> <span *ngIf="isControlRequired('invoiceAddressCountry')">*</span>
                </label>
                <input id="invoiceAddressCountry"
                       type="text"
                       name="invoiceAddressCountry"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.addressCountry}"
                       formControlName="invoiceAddressCountry"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('invoiceAddressCountry')"
                                     [formCtrl]="billingInfoForm.get('invoiceAddressCountry')"></validation-messages>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #deliveryBlock>
    <h5 class="kt-portlet__head-title"><span translation="Delivery" source=""></span></h5>
    <div class="kt-portlet__body" [formGroup]="billingInfoForm">
        <div class="row">
            <div class="form-group col-12 col-sm-4">
                <label for="deliveryContactName">
                    <span translation="ContactName" source=""></span> <span *ngIf="isControlRequired('deliveryContactName')">*</span>
                </label>
                <input id="deliveryContactName"
                       type="text"
                       name="deliveryContactName"
                       class="form-control"
                       formControlName="deliveryContactName"
                       [ngClass]="{'edited':billingInfo.contactName}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('deliveryContactName')"
                                     [formCtrl]="billingInfoForm.get('deliveryContactName')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="deliveryAddress">
                    <span translation="Address" source=""></span> <span *ngIf="isControlRequired('deliveryAddress')">*</span>
                </label>
                <textarea id="deliveryAddress"
                          rows="1"
                          name="deliveryAddress"
                          class="form-control"
                          [ngClass]="{'edited':billingInfo.deliveryAddress}"
                          formControlName="deliveryAddress"
                          maxlength="256"></textarea>

                <validation-messages *ngIf="isControlRequired('deliveryAddress')"
                                     [formCtrl]="billingInfoForm.get('deliveryAddress')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="deliveryAddressHouseNumber">
                    <span translation="AddressHouseNumber" source=""></span> <span *ngIf="isControlRequired('deliveryAddressHouseNumber')">*</span>
                </label>
                <input id="deliveryAddressHouseNumber"
                       type="text"
                       name="deliveryAddressHouseNumber"
                       class="form-control"
                       formControlName="deliveryAddressHouseNumber"
                       [ngClass]="{'edited':billingInfo.deliveryAddressHouseNumber}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('deliveryAddressHouseNumber')"
                                     [formCtrl]="billingInfoForm.get('deliveryAddressHouseNumber')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="deliveryAddressPostcode">
                    <span translation="AddressPostcode" source=""></span> <span *ngIf="isControlRequired('deliveryAddressPostcode')">*</span>
                </label>
                <input id="deliveryAddressPostcode"
                       type="text"
                       name="deliveryAddressPostcode"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.deliveryAddressPostcode}"
                       formControlName="deliveryAddressPostcode"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('deliveryAddressPostcode')"
                                     [formCtrl]="billingInfoForm.get('deliveryAddressPostcode')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="deliveryAddressCity">
                    <span translation="AddressCity" source=""></span> <span *ngIf="isControlRequired('deliveryAddressCity')">*</span>
                </label>
                <input id="deliveryAddressCity"
                       type="text"
                       name="city"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.deliveryAddressCity}"
                       formControlName="deliveryAddressCity"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('deliveryAddressCity')"
                                     [formCtrl]="billingInfoForm.get('deliveryAddressCity')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="deliveryAddressCountry">
                    <span translation="AddressCountry" source=""></span> <span *ngIf="isControlRequired('deliveryAddressCountry')">*</span>
                </label>
                <input id="deliveryAddressCountry"
                       type="text"
                       name="deliveryAddressCountry"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.deliveryAddressCountry}"
                       formControlName="deliveryAddressCountry"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('deliveryAddressCountry')"
                                     [formCtrl]="billingInfoForm.get('deliveryAddressCountry')"></validation-messages>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #generalBlock>
    <h5 class="kt-portlet__head-title"><span translation="CustomerSearch" source=""></span></h5>
    <div class="kt-portlet__body" [formGroup]="billingInfoForm">
        <div class="row">
            <div class="form-group col-12 col-sm-4">
                <label for="contactName">
                    <span translation="ContactName" source=""></span> <span *ngIf="isControlRequired('contactName')">*</span>
                </label>
                <input id="contactName"
                       type="text"
                       name="city"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.contactName}"
                       formControlName="contactName"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('contactName')"
                                     [formCtrl]="billingInfoForm.get('contactName')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="phoneNumber">
                    <span translation="AccountTelephoneNumber1" source=""></span> <span *ngIf="isControlRequired('phoneNumber')">*</span>
                </label>
                <input id="phoneNumber"
                       type="text"
                       name="city"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.phoneNumber}"
                       formControlName="phoneNumber"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('phoneNumber')"
                                     [formCtrl]="billingInfoForm.get('phoneNumber')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="phoneNumberSecondary">
                    <span translation="AccountTelephoneNumber2" source=""></span> <span *ngIf="isControlRequired('phoneNumberSecondary')">*</span>
                </label>
                <input id="phoneNumberSecondary"
                       type="text"
                       name="city"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.phoneNumberSecondary}"
                       formControlName="phoneNumberSecondary"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('phoneNumberSecondary')"
                                     [formCtrl]="billingInfoForm.get('phoneNumberSecondary')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="EInvoiceAddress">
                    <span translation="EInvoiceAddress" source=""></span> <span *ngIf="isControlRequired('invoiceEAddress')">*</span>
                </label>
                <input id="EInvoiceAddress"
                       type="text"
                       name="EInvoiceAddress"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.invoiceEAddress}"
                       formControlName="invoiceEAddress"
                       maxlength="256"
                       pattern="^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$">

                <validation-messages *ngIf="isControlRequired('invoiceEAddress')"
                                     [formCtrl]="billingInfoForm.get('invoiceEAddress')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="RememberEInvoiceAddress">
                    <span translation="RememberEInvoiceAddress" source=""></span> <span *ngIf="isControlRequired('invoiceRememberEInvoiceAddress')">*</span>
                </label>
                <input id="RememberEInvoiceAddress"
                       type="text"
                       name="RememberEInvoiceAddress"
                       class="form-control"
                       [ngClass]="{'edited':billingInfo.invoiceRememberEInvoiceAddress}"
                       formControlName="invoiceRememberEInvoiceAddress"
                       maxlength="256"
                       pattern="^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$">

                <validation-messages *ngIf="isControlRequired('invoiceRememberEInvoiceAddress')"
                                     [formCtrl]="billingInfoForm.get('invoiceRememberEInvoiceAddress')"></validation-messages>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #financialBlock>
    <h5 class="kt-portlet__head-title">
        <!--<span translation="Plattform.CustomerSearch.CompanyData" source="Plattform"></span>-->
    </h5>
    <div class="kt-portlet__body" [formGroup]="billingInfoForm">
        <div class="row">
            <div class="form-group col-12 col-sm-4">
                <label for="accountBankName">
                    <span translation="AccountBankName" source=""></span> <span *ngIf="isControlRequired('accountBankName')">*</span>
                </label>
                <input id="accountBankName"
                       type="text"
                       name="accountBankName"
                       class="form-control"
                       formControlName="accountBankName"
                       [ngClass]="{'edited':billingInfo.accountBankName}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('accountBankName')"
                                     [formCtrl]="billingInfoForm.get('accountBankName')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="accountNumber">
                    <span translation="AccountNumber" source=""></span> <span *ngIf="isControlRequired('accountNumber')">*</span>
                </label>
                <input id="accountNumber"
                       type="text"
                       name="accountNumber"
                       class="form-control"
                       formControlName="accountNumber"
                       [ngClass]="{'edited':billingInfo.accountNumber}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('accountNumber')"
                                     [formCtrl]="billingInfoForm.get('accountNumber')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="taxVatNo">
                    <span translation="Tax/VatNo" source=""></span> <span *ngIf="isControlRequired('taxVatNo')">*</span>
                </label>
                <input id="taxVatNo"
                       type="text"
                       name="taxVatNo"
                       class="form-control"
                       formControlName="accountNumber"
                       [ngClass]="{'edited':billingInfo.taxVatNo}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('taxVatNo')"
                                     [formCtrl]="billingInfoForm.get('taxVatNo')"></validation-messages>
            </div>
            <div class="form-group col-12 col-sm-4">
                <label for="registrationNo">
                    <span translation="RegistrationN" source=""></span> <span *ngIf="isControlRequired('registrationNo')">*</span>
                </label>
                <input id="registrationNo"
                       type="text"
                       name="registrationNo"
                       class="form-control"
                       formControlName="registrationNo"
                       [ngClass]="{'edited':billingInfo.registrationNo}"
                       maxlength="64">

                <validation-messages *ngIf="isControlRequired('registrationNo')"
                                     [formCtrl]="billingInfoForm.get('registrationNo')"></validation-messages>
            </div>
        </div>
    </div>
</ng-template>
